import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import avatar from "../../../assets/images/gymPlaceholder.svg";

const InvoiceDetail = () => {
  document.title = "Invoice | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const invoiceRef = useRef(null);
  const redeemId = location.state?.redeemData?.data[0]?._id;

  const [redeemData, setRedeemData] = useState();
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);

  const fetchRedeemPass = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.redeemDetail}?gymId=${id}`);
      setRedeemData(response?.data?.data[0]);
      setContent(response?.data?.data[0]?.passDetail?.content?.htmlContent);
    } catch (error) {
      console.error("Error fetching pass data:", error);
      setRedeemData(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (redeemId) {
      fetchRedeemPass(redeemId);
    }

    document.title = "Invoice Detail | Elevated Iron";
  }, []);

  const printInvoice = async () => {
    const element = invoiceRef.current;
    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      console.error("Failed to open print window.");
      return;
    }

    const elementHtml = element.outerHTML;
    const styles = Array.from(document.styleSheets)
      .map((styleSheet) => {
        try {
          return Array.from(styleSheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch {
          return "";
        }
      })
      .join("\n");

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Invoice Detail | Elevated Iron</title>
          <style>${styles}</style>
        </head>
        <body onload="window.print(); window.close();">
          ${elementHtml}
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  // const downloadPDF = async () => {
  //   if (!redeemData?.userPassDetail?.acknowledgment?.data) return;

  //   try {
  //     const element = invoiceRef.current;

  //     // Wait for images to load before rendering
  //     const images = Array.from(element.querySelectorAll("img"));
  //     await Promise.all(
  //       images.map(
  //         (img) =>
  //           new Promise((resolve, reject) => {
  //             if (img.complete) {
  //               resolve();
  //             } else {
  //               img.onload = resolve;
  //               img.onerror = reject;
  //             }
  //           })
  //       )
  //     );

  //     // Use html2canvas with additional settings for cross-origin and better scaling
  //     const canvas = await html2canvas(element, {
  //       scale: 2, // Increase scale for better quality
  //       useCORS: true, // Allow CORS for external images
  //       allowTaint: true, // Allow tainting images for better compatibility
  //     });

  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");

  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     pdf.save(`invoice_${redeemData?._id}.pdf`);
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //   }
  // };
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <React.Fragment>
      <div ref={invoiceRef}>
        <Container fluid>
          <Row>
            <Col lg="12">
              <Card className="rounded-4 p-4">
                <Row className="justify-content-between align-items-center">
                  <Col md={6}>
                    <h2 className="fw-bold font-size-20 ff-sora primary-black">
                      Redeem Pass Invoice
                    </h2>
                  </Col>
                </Row>
                <CardBody>
                  {/* <div className="invoice-title">
                    <h4 className="float-end ff-sora font-size-16">
                      Invoice # {redeemData?.invoiceID}
                      <span className="badge bg-success ff-sora font-size-16 ms-2">
                        Paid
                      </span>
                    </h4>
                    <div className="mb-4">
                      <img src={logo} alt="logo" height="20" />
                    </div>
                    <div className="text-muted">
                      <p className="ff-sora font-size-16 mb-1">
                        {redeemData?.shippingAddress}
                      </p>
                      <p className=" ff-sora font-size-16 mb-1">
                        <i className="uil uil-envelope-alt me-1"></i>{" "}
                        {redeemData?.shippingEmail}
                      </p>
                      <p className="ff-sora font-size-16">
                        <i className="uil uil-phone me-1"></i>{" "}
                        {redeemData?.shippingPhoneno}
                      </p>
                    </div>
                  </div>
                  <hr className="my-4" /> */}
                  <Row>
                    <Col sm="6">
                      <div className="text-muted ff-sora font-size-16">
                        <h5 className="ff-sora font-size-16 mb-3">
                          Invoice To:
                        </h5>

                        <h5 className="ff-sora font-size-15 mb-2 text-capitalize">
                          {`${redeemData?.userDetail?.firstName} ${
                            redeemData?.userDetail?.lastName
                              ? ` ${redeemData?.userDetail?.lastName}`
                              : ""
                          }`}
                        </h5>

                        <p className="ff-sora font-size-16 mb-1">
                          {redeemData?.userDetail?.email}
                        </p>
                        <p className="ff-sora font-size-16 mb-1">
                          {redeemData?.userDetail?.phoneNumber}
                        </p>
                      </div>
                    </Col>
                    <Col sm="6">
                      <div className="text-muted text-sm-end">
                        <div className="">
                          <h5 className="ff-sora font-size-16 mb-1">
                            Invoice No:
                          </h5>
                          <p className="ff-sora font-size-16">
                            {redeemData?._id}
                          </p>
                        </div>
                        <div className="mt-4">
                          <h5 className="ff-sora font-size-16 mb-1">
                            Invoice Date:
                          </h5>
                          <p className="ff-sora font-size-16">
                            {new Date(
                              redeemData?.createdAt
                            ).toLocaleDateString()}
                          </p>
                        </div>
                        <div className="mt-4">
                          <h5 className="ff-sora font-size-16 mb-1">
                            Order No:
                          </h5>
                          <p className="ff-sora font-size-16">
                            #{redeemData?._id}
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="py-2">
                    <h5 className="ff-sora font-size-15">Summary</h5>
                    <div className="table-responsive hide-scrollbar">
                      <Table className="table-nowrap table-centered mb-0">
                        <thead className="light-green">
                          <tr className="light-green">
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Pass ID
                            </th>
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Gym/Club
                            </th>
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Pass Title
                            </th>
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Pass Type
                            </th>
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Pass Price
                            </th>
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Created On
                            </th>
                            <th className="primary-black fw-bold ff-sora font-size-14">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody style={{ minHeight: "550px" }}>
                          {loading ? (
                            <tr>
                              <td colSpan={8} className="text-center">
                                <div className="d-flex justify-content-center align-items-center">
                                  <div
                                    className="spinner-border"
                                    style={{
                                      width: "3rem",
                                      height: "3rem",
                                      color: "#3BABA6",
                                    }}
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : redeemData.length === 0 ? (
                            <></>
                          ) : (
                            <>
                              <tr>
                                <td className="ff-sora font-size-14">
                                  {redeemData?._id}
                                </td>
                                <td>
                                  <h5 className="ff-sora font-size-14 mb-2">
                                    {redeemData?.gymDetail?.name}
                                  </h5>
                                  <ul className="list-inline mb-1 ">
                                    <li className="list ff-sora font-size-12">
                                      Email :
                                      <span className="fw-medium ff-sora font-size-12">
                                        {redeemData?.gymDetail?.email}
                                      </span>
                                    </li>
                                    <li className="list-inline-item ff-sora font-size-12">
                                      Contact No. :
                                      <span className="fw-medium ff-sora font-size-12">
                                        {redeemData?.gymDetail?.phoneNumber}
                                      </span>
                                    </li>
                                  </ul>
                                </td>
                                <td className="ff-sora font-size-14">
                                  {redeemData?.passDetail?.name}
                                </td>
                                <td className="ff-sora font-size-14">
                                  {redeemData?.passDetail.duration === "oneweek"
                                    ? "One Week"
                                    : redeemData?.passDetail.duration ===
                                      "oneday"
                                    ? "One Day"
                                    : redeemData?.passDetail.duration ===
                                        "onemonth" && "One Month"}
                                </td>
                                <td className=" ff-sora font-size-14">
                                  $
                                  {`${formatNumber(
                                    parseFloat(redeemData?.passDetail?.price)
                                  )}`}
                                </td>
                                <td className=" ff-sora font-size-14">
                                  {new Date(
                                    redeemData?.passDetail.createdAt
                                  ).toLocaleDateString()}
                                </td>
                                <td className="ff-sora font-size-14">
                                  {`$${formatNumber(
                                    parseFloat(redeemData?.passPrice)
                                  )}`}
                                </td>
                              </tr>

                              <tr>
                                <th
                                  colSpan="4"
                                  className="text-end ff-sora font-size-16"
                                >
                                  Sub Total
                                </th>
                                <td className="text-end ff-sora font-size-16">
                                  {`$${formatNumber(
                                    parseFloat(redeemData?.passPrice)
                                  )}`}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  colSpan="4"
                                  className="border-0 ff-sora font-size-16 text-end"
                                >
                                  Discount :
                                </th>
                                <td className="border-0 ff-sora font-size-16 text-end">
                                  -{" "}
                                  {`$${formatNumber(
                                    parseFloat(redeemData?.passPrice * 0.1)
                                  )}`}
                                </td>
                              </tr>

                              <tr>
                                <th
                                  colSpan="4"
                                  className="border-0 ff-sora font-size-16 text-end"
                                >
                                  Platform Fee
                                </th>
                                <td className="border-0 ff-sora font-size-16 text-end">
                                  -{" "}
                                  {`$${formatNumber(
                                    parseFloat(redeemData?.passPrice * 0.1)
                                  )}`}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  colSpan="4"
                                  className="border-0 ff-sora font-size-16 text-end"
                                >
                                  Total
                                </th>
                                <td className="border-0 text-end">
                                  <h4 className="ff-sora font-size-16 m-0">
                                    {`$${formatNumber(
                                      parseFloat(redeemData?.passPrice * 0.8)
                                    )}`}
                                  </h4>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <Row>
                      <Col sm="12" className="bg-light border-1 p-3 rounded-2 ">
                        <div className=" ff-sora font-size-16">
                          <h5 className="ff-sora font-size-16">
                            Acknowledgement:
                          </h5>

                          <div
                            dangerouslySetInnerHTML={{ __html: content }}
                          ></div>
                        </div>
                        <div className="d-flex flex-column">
                          <h5 className="ff-sora font-size-16 mb-3">
                            Signature:
                          </h5>
                          <div className="d-flex flex-column align-items-start">
                            <img
                              src={
                                redeemData?.userPassDetail?.acknowledgment
                                  ?.data === null
                                  ? avatar
                                  : `${process.env.REACT_APP_IMG_URL}${redeemData?.userPassDetail?.acknowledgment?.data}`
                              }
                              alt={`${redeemData?.userPassDetail?.acknowledgment?.type} logo`}
                              className="object-fit-cover"
                              maxWidth={"200px"}
                              height={"100px"}
                            />
                            <div
                              style={{
                                border: "1px solid black",
                                width: "100px",
                                height: "2px",
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="d-print-none mt-4">
                      <div className="float-end">
                        {/* <Link
                          to="#"
                          onClick={downloadPDF}
                          className="rounded-pill1 me-1"
                        >
                          <i className="fa fa-download"></i>
                        </Link> */}
                        <Link
                          to="#"
                          onClick={printInvoice}
                          className="rounded-pill1 me-1"
                        >
                          <i className="fa fa-print"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  height: "60px",
                  position: "sticky",
                  bottom: "0",
                  zIndex: "10",
                }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InvoiceDetail;
